import { Extension } from '@tiptap/core';

const CustomEnter = Extension.create({
  name: 'customEnter',

  addOptions() {
    return {
      enterKeyHandler: null,
    };
  },

  addKeyboardShortcuts() {
    return {
      Enter: ({ editor }) => {
        return this.options.enterKeyHandler(editor);
      },
      'Shift-Enter': ({ editor }) => {
        // In a list, Shift-Enter continues the list with the next bullet/number.
        // splitListItem bails on an empty item, so the fallback lift is what exits
        // list mode when you hit Shift-Enter twice.
        if (editor.isActive('bulletList') || editor.isActive('orderedList')) {
          return editor.commands.first(({ commands }) => [
            () => commands.splitListItem('listItem'),
            () => commands.liftListItem('listItem'),
          ]);
        }

        editor.commands.splitBlock();
        return true;
      },
    };
  },
});

export default CustomEnter;
